// The day a replacement-flight search keys on. The BFF search (and the airline schedule
// behind it) takes a UTC calendar day, so both helpers speak UTC `YYYY-MM-DD`.

/** Today's UTC calendar day, `YYYY-MM-DD`. */
export function todayUtc(now: number = Date.now()): string {
  return new Date(now).toISOString().slice(0, 10);
}

/** The disrupted departure's day — or today once that day is past (a replacement leaves from now on). */
export function searchDayOf(departureAt: string | undefined, now: number = Date.now()): string | undefined {
  const day = departureAt ? departureAt.slice(0, 10) : undefined;
  const today = todayUtc(now);
  return day && day < today ? today : day;
}

/** A searched day already behind us (the live schedule holds nothing for it). */
export function isPastDay(day: string | undefined, now: number = Date.now()): boolean {
  return !!day && day < todayUtc(now);
}
